/**
 * @generated SignedSource<<95abf8e1b07bd44658c1a45bfaa937b1>>
 * @relayHash 06204e92b8e172e5b2552405558bd698
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 05c894713817de611bcc11d5de29c964eb7362e1524c8b683a8b3717c7b43a6e

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { mainIssueAggQuery } from './mainIssueAggQuery.graphql';

const node: PreloadableConcreteRequest<mainIssueAggQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "05c894713817de611bcc11d5de29c964eb7362e1524c8b683a8b3717c7b43a6e",
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "jira",
            "issueByKey",
            "attachments"
          ]
        }
      ]
    },
    "name": "mainIssueAggQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
